// extracted by mini-css-extract-plugin
export default {"form":"Form_form__D3tWv","profile":"Form_profile__rlrWf Form_form__D3tWv","fieldset":"Form_fieldset__fA1T5","title":"Form_title__eHnB6"};